import { useState } from "react";
import Switch from "react-switch";
import Select from "react-select";
import { useStore } from "../../../store";
import { toJS } from "mobx";
import DateTime from "../../../components/DateTime";
import moment from "moment";
import { FiDelete } from "react-icons/fi";
import { IoReturnDownBackSharp } from "react-icons/io5";
import "./index.css";

function MeunSettingScreenLock() {
  const { dataStore } = useStore();

  const [screenLock, setScreenLock] = useState(false);
  const [pin, setPin] = useState("");
  // 开关
  let onChangeScreenLock = function () {
    setScreenLock(!screenLock);
  };
  // pin
  let onClickPin = function (value: string) {
    let t = pin;

    if (value === "delete") {
      t = t.slice(0, t.length - 1);
      value = "";
    }

    if (value === "enter") {
      //console.log("保存", pin);
      return;
    }
    setPin(t + value);
  };
  return (
    <div className="w-4/6 relative mr-10">
      <div className="border-2 rounded-2xl absolute inset-0 m-auto h-5/6 opacity-1 mr-10" style={{
        backgroundColor: 'rgba(212,115,0,0.5)',
        boxShadow: "8px 8px 8px  rgba(0, 0, 0, 0.3)",
      }}>
        <div className="h-[500px] overflow-auto m-10">
          <div className="h-12 px-28">
            <span className="float-left text-white text-3xl mt-1">
              Screen lock
            </span>
            <Switch
              onChange={onChangeScreenLock}
              checked={screenLock}
              uncheckedIcon={false}
              checkedIcon={false}
              onColor={"#5ede4e"}
              className="mt-[7px] float-right mr-24"
            />
          </div>
          <br></br>
          <div className="h-12 px-28">
            <span className="float-left text-white text-3xl mt-1">Set Pin</span>
            <div className="float-right h-60 w-[240px] text-center">
              <input
                className="w-32 text-center rounded-2xl h-8 text-2xl"
                type="password"
                value={pin}
              ></input>

              <table className="w-full h-52 mt-4">
                <tr>
                  <td
                    className="input-number-content"
                    onClick={() => onClickPin("1")}
                  >
                    1
                  </td>
                  <td
                    className="input-number-content"
                    onClick={() => onClickPin("2")}
                  >
                    2
                  </td>
                  <td
                    className="input-number-content"
                    onClick={() => onClickPin("3")}
                  >
                    3
                  </td>
                </tr>
                <tr>
                  <td
                    className="input-number-content"
                    onClick={() => onClickPin("4")}
                  >
                    4
                  </td>
                  <td
                    className="input-number-content"
                    onClick={() => onClickPin("5")}
                  >
                    5
                  </td>
                  <td
                    className="input-number-content"
                    onClick={() => onClickPin("6")}
                  >
                    6
                  </td>
                </tr>
                <tr>
                  <td
                    className="input-number-content"
                    onClick={() => onClickPin("7")}
                  >
                    7
                  </td>
                  <td
                    className="input-number-content"
                    onClick={() => onClickPin("8")}
                  >
                    8
                  </td>
                  <td
                    className="input-number-content"
                    onClick={() => onClickPin("9")}
                  >
                    9
                  </td>
                </tr>
                <tr>
                  <td
                    className="input-number-content"
                    onClick={() => onClickPin("delete")}
                  >
                    <FiDelete
                      style={{
                        fontSize: "28px",
                        display: "revert",
                        verticalAlign: "revert",
                      }}
                    />
                  </td>
                  <td
                    className="input-number-content"
                    onClick={() => onClickPin("0")}
                  >
                    0
                  </td>
                  <td
                    className="input-number-content"
                    onClick={() => onClickPin("enter")}
                  >
                    <IoReturnDownBackSharp
                      style={{
                        fontSize: "28px",
                        display: "revert",
                        verticalAlign: "revert",
                      }}
                    />
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default MeunSettingScreenLock;
